module.exports = __webpack_public_path__ + "img/logo-circle.dcbff4d4.svg";